// extracted by css-extract-rspack-plugin
export default {"DatasetValueProp":"NewDatasetModal-module__DatasetValueProp___yvbEc"};